<template>
  <el-dialog
    title="Check Review"
    :visible.sync="dialogVisible"
    size="large"
    id="check-printer-dialog"
    :style="`${ active === 2 ? 'z-index: 11000 !important' : ''}`"
    top="5%"
    @close="resetFields"
    :show-close="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <el-row type="flex" align="middle" justify="between" style="padding: 0 20px; margin-bottom: 12px;">
      <el-col :span="12">
        <el-row type="flex" align="middle" justify="start" style="padding: 10px 0;">
          <el-steps :space="200" :active="active" finish-status="success" :center="true">
            <el-step title="Review" description="transactions" />
            <el-step title="Print" description="checks" />
            <el-step title="Summarize" description="check run" />
          </el-steps>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="end" align="middle" style="padding: 20px 0 0 0;">
          <div
            v-if="active === 1"
            style="padding: 0 12px;">
            Did these checks print correctly?
          </div>
          <el-button
            v-if="active === 1"
            plain
            :disabled="buildProgress !== 100"
            @click="reprintChecks">
            No
          </el-button>
          <el-button
            v-if="active === 0 && !printErrors"
            plain
            @click="closeCheckPrinter">
            Cancel
          </el-button>
          <el-button
            v-if="active === 0 && !printErrors"
            type="success"
            :disabled="disablePrint"
            @click="goToNextStep">
            Print
          </el-button>
          <el-button
            v-if="active === 0 && printErrors"
            type="danger"
            @click="skipToLastStep"
            :disabled="!!enableReprintBtn">
            All checks printed
          </el-button>
          <el-button
            v-if="active === 2"
            type="plain"
            :loading="processingReport"
            @click="generateCheckRegisterReport">
            {{ processingReport ? 'Working' : 'Check Register Report' }}
          </el-button>
          <el-button
            v-if="active === 0 && printErrors"
            type="success"
            @click="goToNextStep"
            :disabled="!enableReprintBtn">
            Reprint
          </el-button>
          <el-button
            v-else-if="active === 1"
            type="success"
            :disabled="buildProgress !== 100"
            @click="goToNextStep">
            Yes
          </el-button>
          <el-button
            v-else-if="active === 2"
            type="success"
            @click="closeCheckPrinter">
            Done
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="between" style="padding: 0 20px; margin-bottom: 12px;" v-if="active === 0 && selectionPaymentType">
      <el-col :span="3">
        Payment Method<sup>*</sup>
      </el-col>
      <el-col :span="6">
        <el-select name="payment_method" v-model="payment_method" @change="handlePaymentMethod" class="keynav">
          <el-option
            v-for="(option, key) in paymentMethods"
            :key="key"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-col>
    </el-row>
    <div style="padding: 0 20px;" v-loading.body="updatingTransactions" element-loading-text="Updating...">
      <el-carousel
        arrow="never"
        :initial-index="0"
        :autoplay="false"
        :height="`${checkPdfHeight + 50}px`"
        ref="checkCarousel"
        indicator-position="none">
        <el-carousel-item style="overflow-y: scroll;">
          <el-row>
            <el-col>
              <el-row type="flex" style="margin-top: 12px;">
                <h4 style="font-weight: bold; margin: 0;">{{getBankById(selectedBank).name}}</h4>
              </el-row>
              <el-row v-if="!printErrors" type="flex" style="font-size: 0.8em; padding: 6px 0;">First available check number:</el-row>
              <el-row v-if="!printErrors" type="flex" justify="start" align="middle">
                <el-col :span="3">
                  <el-input
                    :name="`${selectedBank}_check_range_start`"
                    size="small"
                    placeholder="Check range start"
                    v-model="startingCheckNumbers[selectedBank]"
                    @blur="updateCheckNumbers">
                  </el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <h3 v-if="!printErrors" style="font-weight: 100;">Review Checks</h3>
          <h3 v-else style="font-weight: 300; color: darkred">
            Please select checks that did not print correctly
          </h3>
          <el-row type="flex" justify="center">
            <el-form ref="checkForm" v-loading.body="updatingCheckNumbers" element-loading-text="Updating...">
              <table id="check-review-form">
                <tbody>
                  <tr>
                    <td class="cell-gray">Check #</td>
                    <td class="cell-gray">Amount</td>
                    <td class="cell-gray">Payee</td>
                    <td class="cell-gray">Company</td>
                    <td class="cell-gray" v-if="checkDateRange">
                      Date{{ allowableDateRangeString ? ` (${allowableDateRangeString})` : '' }}<span style="color: red;"> *</span>
                    </td>
                    <td class="cell-gray">Memo<span style="color: red;"> *</span></td>
                    <td class="cell-gray">Combine</td>
                    <td class="cell-gray" v-if="!printErrors">Period</td>
                    <td class="cell-gray" v-if="printErrors">Print error</td>
                  </tr>
                  <tr v-if="!printErrors" v-for="(c, i) in checkPreviews" :key="`a${c.check}`">
                    <td>
                      <el-input
                        :name="`${c.check}__number`"
                        v-model="checkPreviews[i].form['number']"
                        disabled
                        class="keynav"
                      />
                    </td>
                    <td>
                      <MoneyField
                        style="text-align: left;"
                        :name="`${c.check}__amount_decimal`"
                        v-model="checkPreviews[i].form['amount_decimal']"
                        :disabled="true"
                        class="keynav check-amt-field"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__payee`"
                        v-model="checkPreviews[i].form.payee_name"
                        disabled
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__company`"
                        v-model="checkPreviews[i].form.company.label"
                        disabled
                        class="keynav"
                      />
                    </td>
                    <td v-if="checkDateRange">
                      <DateField
                        :customStyle="{ width: '100%' }"
                        :name="`${c.check}__date`"
                        :allowableRange="{
                          start: checkDateRange.start,
                          end: checkDateRange.end,
                          errMsg: `Check date must be between ${allowableDateRangeString}`
                        }"
                        v-model="checkPreviews[i].form.date"
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__description`"
                        v-model="checkPreviews[i].form.description"
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-checkbox
                        style="margin: 0 0 0 25px;"
                        class="keynav"
                        :name="`${c.check}__payment_combine_checks`"
                        v-model="checkPreviews[i].form.payment_combine_checks"
                        @change="updateTransactions(checkPreviews[i], 'payment_combine_checks')"
                      />
                    </td>
                    <td>
                      <el-select :name="`${c.check}__period`" v-model="checkPreviews[i].form.period" class="keynav" style="width: 100%;">
                        <el-option
                          v-for="(option, key) in periodOptions"
                          :key="key"
                          :label="option.label"
                          :value="option.value"
                        />
                      </el-select>
                    </td>
                  </tr>
                  <tr v-if="printErrors" v-for="(v, i) in checks" :key="v.id">
                    <td style="padding: 6px 12px;">
                      <div>{{ v.number }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ formatAmountLocale(v.amount_decimal) }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ getVendorById(v.vendor).name }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ getCompanyByBatchId(v.batch).name }}</div>
                    </td>
                    <td v-if="checkDateRange">
                      <DateField
                        :customStyle="{ width: '100%' }"
                        :name="`${v.check}__date`"
                        :allowableRange="{
                          start: checkDateRange.start,
                          end: checkDateRange.end,
                          errMsg: `Check date must be between ${allowableDateRangeString}`
                        }"
                        :disabled="true"
                        v-model="checkPreviews[i].form.date"
                        class="keynav"
                      />
                    </td>
                    <td class="cell-padded">
                      <div>{{ v.description }}</div>
                    </td>
                    <td>
                      <div style="text-align: center;">
                        <input
                          type="checkbox"
                          :disabled="true"
                          :name="`${v.id}__payment_combine_checks`"
                          v-model="v.payment_combine_checks"
                          class="keynav">
                      </div>
                    </td>
                    <td class="cell-padded">
                      <div style="text-align: center;">
                        <input
                          type="checkbox"
                          :name="`${v.id}__printerr`"
                          v-model="checks[i].printErr"
                          @change="handlePrintErrCheckboxChange"
                          class="keynav" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-form>
          </el-row>
        </el-carousel-item>
        <el-carousel-item>
          <h3 style="font-weight: 100;">Print Checks</h3>
          <el-row
            v-if="building && !checkPdfReady"
            type="flex"
            justify="center"
            align="middle"
            style="padding: 25px 0;">
            <el-progress type="circle" :percentage="buildProgress" />
          </el-row>
          <el-row v-if="!building && checkPdfReady" type="flex" justify="center" align="middle">
            <iframe
              :src="checkPdfReady ? `data:application/pdf;base64,${getCheckrunPdf}` : ''"
              :height="checkPdfHeight"
              width="100%"
              frameborder="0"
            />
          </el-row>
        </el-carousel-item>
        <el-carousel-item>
          <el-row style="padding: 12px 0; font-size: 18px;">
            All set
          </el-row>
          <el-row style="font-weight: 500;">
            The following checks have been printed:
          </el-row>
          <el-row>
            <ul>
              <li v-for="p in postedChecks" style="padding: 6px 0;">
                Check #{{ p.number }}, paid to <strong>{{ getVendorById(p.vendor).name }}</strong> for {{ getCurrencySymbol(p) }}<strong>{{ formatAmountLocale(p.amount_decimal) }}</strong>
              </li>
            </ul>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import printJS from 'print-js'
  import prepareFormData from '@/utils/helpers/PrepareFormData'
  import { payload as checkPayload } from '@/components/RouteComponents/Checks/actionPayload'
  import { payload as batchPayload } from '@/components/RouteComponents/Batches/actionPayload'
  import MoneyField from '@/components/InputComponents/MoneyField.vue'
  import DateField from '@/components/InputComponents/DateField.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'

  export default {
    name: 'checkPrinter',
    components: {
      MoneyField,
      DateField
    },
    props: {
      checksToPrint: Array,
      selectedBank: String || null,
      checkPrinterVisible: Boolean,
      getNumOfChecksToPrintPerBank: Function,
      postedChecks: Array,
      resetParentFields: Function,
      draftChecks: Array,
      selectionPaymentType: String || null
    },
    data () {
      return {
        error: null,
        dialogVisible: false,
        active: 0,
        startingCheckNumbers: {},
        checks: [],
        checkPreviews: [],
        checkPdfReady: false,
        checkPdfHeight: window.innerHeight - 400,
        checkKey: 0,
        building: false,
        buildProgress: 0,
        printErrors: false,
        enableReprintBtn: false,
        checkRuns: [],
        updatingTransactions: false,
        paymentTypeUpdated: false,
        changingPaymentMethod: false,
        payment_method: 'CHECK',
        paymentMethods: [
          { id: 1, label: 'Check', value: 'CHECK' },
          { id: 2, label: 'Wire Transfer', value: 'WIRE' },
          { id: 3, label: 'EFT', value: 'EFT' },
          { id: 4, label: 'Manual Check', value: 'CHECK_MANUAL' }
        ],
        updatingCheckNumbers: false,
        disablePrint: false,
        fields: [
          {
            name: 'number',
            label: 'Check #'
          },
          {
            name: 'amount_decimal',
            label: 'Amount',
            required: true
          },
          {
            name: 'payee_name',
            label: 'Payee',
            disabled: true,
            required: true
          },
          {
            name: 'bank',
            label: 'Bank',
            disabled: true
          },
          {
            name: 'company',
            label: 'Company',
            required: true
          },
          {
            name: 'description',
            label: 'Memo',
            required: false
          },
          {
            name: 'period',
            label: 'Period',
            required: true
          },
          {
            name: 'pickup',
            label: 'Pickup',
            required: true
          },
          {
            name: 'reprint',
            label: 'Reprint'
          }
        ]
      }
    },
    methods: {
      formatAmountLocale (value) {
        return formatAmount(value)
      },
      /**
       * Generates a check register report
       */
      async generateCheckRegisterReport () {
        try {
          const endpoint = 'checks/register/'
          const opts = await this.$store.dispatch('fetchFormFields', `reports/${endpoint}`)
          if (this.checkRuns.length) {
            this.cachingParams = true
            const resp = await this.$store.dispatch('cacheParams', { data: { check_run: this.checkRuns[0].id, include_computer_check: true } })
            this.cachingParams = false
            if (!resp && resp.id) {
              throw new Error('Unable to cache parameters')
            }
            let { id, reportId } = resp
            const payload = { query: { cached_parameters: id }, type: endpoint, reportId }
            if (opts && opts.template_parameter && opts.templates && Object.keys(opts.templates).length) {
              payload.query[opts.template_parameter] = Object.keys(opts.templates)[0]
            }
            this.$store.dispatch('startRenderingReport', payload)
          }
        } catch (e) {
          console.log(e)
          notify(this, 'warning', `Error generating check register report${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * Go to next step in CheckPrinter carousel
       */
      async goToNextStep () {
        if (this.active < 3) {
          this.active++
          switch (this.active) {
            case 1:
              this.building = true
              if (this.selectionPaymentType !== 'CHECK') {
                this.updatePaymentType(this.payment_method)
                this.paymentTypeUpdated = true
              }
              if (this.printErrors) {
                this.$refs.checkCarousel.next()
                this.postPrintedChecks()
                this.createCheckrun({
                  checks: [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))]                  // TODO: how do we want to handle reprints? Should we create checks anew? Or just another check run?
                })
              } else {
                if (this.verifyCheckForms()) {
                  if (this.verifyCheckAmount()) {
                    let amountConfirm = await this.$confirm('0.00 check about to be printed. Proceed?', 'Warning', {
                      confirmButtonText: 'OK',
                      cancelButtonText: 'Cancel',
                      type: 'warning',
                      closeOnClickModal: false,
                      closeOnPressEscape: false
                    })
                    if (amountConfirm !== 'confirm') {
                      this.closeCheckPrinter()
                    }
                  }
                  this.$refs.checkCarousel.next()
                  this.createBatches()
                } else {
                  if (this.paymentTypeUpdated) {
                    this.updatePaymentType(this.selectionPaymentType)
                    this.paymentTypeUpdated = false
                  }
                  notify(this, 'warning', 'Please fill all required fields')
                  this.active--
                }
              }
              break
            case 2:
              this.postPrintedChecks()
              this.$refs.checkCarousel.next()
              this.printErrors = false
          }
        }
      },
      /**
       * Go to previous step in CheckPrinter carousel
       */
      goToPreviousStep () {
        if (this.active > 0) {
          if (this.checks.length) {
            this.checks.forEach((check) => {
              const preview = this.checkPreviews.find(x => String(x.form.number) === check.number)
              if (preview) {
                check.payment_combine_checks = preview.form.payment_combine_checks
              }
              return check
            })
          }
          this.active--
          this.$refs.checkCarousel.prev()
        }
      },
      /**
       * Skip to last step in CheckPrinter carousel
       */
      skipToLastStep () {
        this.active = 2
        this.printErrors = false
        this.checks.map(v => {
          v.printErr = false
          return v
        })
        this.$refs.checkCarousel.setActiveItem(2)
        this.postPrintedChecks()
      },
      /**
       * Verify that each check has a value for number and description. If this.checkDateRange is not null, checks for
       * a valid date as well. Returns true if all conditions apply.
       */
      verifyCheckForms () {
        return this.checkPreviews.every(preview => {
          let hasNumberAndDescription = preview.form.number && preview.form.description
          return this.checkDateRange ? (hasNumberAndDescription && preview.form.date) : hasNumberAndDescription
        })
      },
      verifyCheckAmount () {
        return this.checkPreviews.some(preview => {
          return (preview.form.amount_decimal === 0.00 || preview.form.amount_decimal === '0.00')
        })
      },
      updatePaymentType (paymentType) {
        this.checkPreviews.forEach(preview => {
          if (preview.form.number && preview.form.number !== '' && preview.form.id) {
            return
          }
          preview.form.related_transactions.forEach((transaction) => {
            this.$store.dispatch(`updateAp`, { id: transaction, data: { payment_type: paymentType } })
          })
        })
      },
      /**
       * Creates batches for checks and checkruns. First, ensures that each check preview has a 'batch' property
       * Then instantiates new instance of the Set class, passing in an array of stringified check preview batches.
       * This creates an array of distinct string representations of batches. Then, we can parse them back to objects
       * and create an array of promises that dispatch a 'save' action for each distinct batch. Once we have this
       * array of promises, we call Promise.all(promises) and save the distinct batches. Finally, we associate each
       * check preview with the correct batch id
       */
      async createBatches () {
        try {
          const distinctBatches = [...new Set(this.checkPreviews
            .filter(preview => !!preview.form.batch)
            .map(preview => JSON.stringify(preview.form.batch))
          )]
          const promises = distinctBatches.map(stringifiedBatch => {
            const data = JSON.parse(stringifiedBatch)
            return this.$store.dispatch('save', { ...batchPayload, data })
          })
          const resp = await Promise.all(promises)
          if (!(resp && resp.length)) {
            throw new Error('Unable to create check run batch')
          }
          this.checkPreviews = this.checkPreviews.map(preview => {
            const correspondingBatchModel = resp.find(batch => {
              const { company, production, bank } = preview.form.batch
              return company === batch.company && production === batch.production && bank === batch.bank
            })
            preview.form.batch = correspondingBatchModel ? correspondingBatchModel.id : null
            return preview
          })
          this.buildProgress = 25
          this.createChecks()
        } catch (e) {
          console.log(e)
          notify(this, 'error', `Error saving checks${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * Creates checks once APs have been selected
       */
      async createChecks () {  // Create check models from check run quote (preview)
        let promises = []
        this.checkPreviews.forEach(preview => {
          const check = { ...preview }
          check.form.date = new Date(check.form.date).toLocaleDateString('fr-CA', { timeZone: 'UTC' })
          if (check.form.number && check.form.number !== '' && check.form.id) {
            const data = { date: check.form.date }
            promises.push(this.$store.dispatch('update', { ...checkPayload, data, id: check.form.id }))
            return
          }
          const data = prepareFormData(check.form)
          promises.push(this.$store.dispatch('save', { ...checkPayload, data }))
        })
        try {
          if (promises.length) {
            const resp = await Promise.all(promises)
            if (!(resp && resp.length)) {
              throw new Error('Unable to create checks')
            }
            this.buildProgress = 50
            this.checks = resp.map(check => {
              check['printErr'] = false
              return check
            })
            for (let check of this.draftChecks) {
              check['printErr'] = false
              this.checks.push(check)
            }
            this.createCheckrun({ checks: [...new Set(resp.map(check => check.id))] })
          } else {
            this.createCheckrun({ checks: [...new Set(this.checkPreviews.map(check => check.form.id))] })
          }                              // ...create check run
        } catch (e) {
          console.log(e)
          if (this.paymentTypeUpdated) {
            this.updatePaymentType(this.selectionPaymentType)
            this.paymentTypeUpdated = false
          }
          notify(this, 'error', `Error saving checks${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * POSTs a check run
       * For each check included in this checkrun, sets a 'printErr' property and sets value to false
       * @param checkIds
       */
      async createCheckrun (checkIds) {
        try {
          const resp = await this.$store.dispatch('saveCheckrun', checkIds)
          if (!(resp && resp.id)) {
            throw new Error('Error saving checks: unable to create check run.')
          }
          this.checkRuns.push(resp)
          this.checks = this.checks.map(check => {
            check.printErr = !checkIds.checks.includes(check.id)
            return check
          })
          for (let check of this.draftChecks) {
            check['printErr'] = false
            this.checks.push(check)
          }
          this.buildProgress = 75
          this.createCheckrunPdf(resp)
        } catch (e) {
          console.log(e)
          if (this.checks.length && this.paymentTypeUpdated) {
            this.updatePaymentType(this.selectionPaymentType)
            this.paymentTypeUpdated = false
          }
          notify(this, 'error', e.message)
        }
      },
      /**
       * Generates a check PDF from a given check run
       * @param run   The check run for which to create a PDF
       */
      async createCheckrunPdf (run) {
        try {
          const bank = this.getBankById(this.selectedBank)
          let payload = {}
          if (bank && bank.check_preferred_template) {
            let opts = await this.$store.dispatch('fetchOptions', { endpoint: 'reports/checks' })
            if (opts && opts.templates && opts.templates[bank.check_preferred_template]) {
              payload[opts.template_parameter] = bank.check_preferred_template
            }
          }
          const resp = await this.$store.dispatch('saveCachedParam', { check_run: run.id })
          if (!(resp && resp.id)) {
            throw new Error('Error caching parameters.')
          }
          payload.cached_parameters = resp.id
          const report = await this.$store.dispatch('buildCheckrunPdf', payload)
          this.buildProgress = 100
          this.building = false
          if (report && report.data) {
            this.checkPdfReady = true
            printJS(this.getCheckrunPdfUrl)
          } else {
            throw new Error('Error generating check PDF.')
          }
        } catch (e) {
          console.log(e)
          if (!(e instanceof DOMException)) {
            this.$notify({ title: 'Error', message: e.message || 'Error saving checks', type: 'error' })
          }
        }
      },
      /**
       * POSTs the checks that have been printed
       */
      async postPrintedChecks () {
        try {
          let printedChecks = this.checks.filter(v => !v.printErr)
          if (!printedChecks || !printedChecks.length) return
          let promises = []
          printedChecks.forEach(check => {
            const data = { status: 'POSTED' }
            let newPayload = Object.assign({}, checkPayload, { data }, { id: check.id })
            promises.push(this.$store.dispatch('update', newPayload))
          })
          const resp = await Promise.all(promises)
          if (!(resp && resp.length)) {
            throw new Error([...new Set(printedChecks.map(v => v.number))].toString())
          }
          this.$notify({
            title: 'Success',
            message: `Posted checks ${[...new Set(resp.map(v => v.number))].toString()}`,
            type: 'success'
          })
          this.updateCheckArrays(resp)
        } catch (e) {
          console.log(e)
          this.$notify({
            title: 'Error',
            message: `Error posting checks${e.message ? ` ${e.message}` : ''}`,
            type: 'error'
          })
        }
      },
      /**
       * Deletes drafts for checks that failed to print
       * TODO: possibly deprecated
       */
      deleteUnprintedDrafts () {
        let unprintedChecks = this.checks.filter(v => v.printErr)
        if (!unprintedChecks || !unprintedChecks.length) return
        let promises = []
        for (let i = 0; i < unprintedChecks.length; i++) {
          let newPayload = Object.assign({}, checkPayload, { id: unprintedChecks[i].id })
          promises.push(this.$store.dispatch('delete', newPayload))
        }
        Promise.all(promises)
          .then(r => console.log(`Deleted checks ${r.toString}`))
          .catch(e => console.log(e))
      },
      /**
       * Add posted checks to this.postedChecks and remove from this.checks
       * @param checks
       */
      updateCheckArrays (checks) {
        const findIndex = (checkId) => {
          for (let j = 0; j < this.checks.length; j++) {
            if (this.checks[j].id === checkId) return j
          }
          return false
        }
        for (let i = 0; i < checks.length; i++) {
          const index = findIndex(checks[i].id)
          if (index) this.checks.splice(index, 1)
          if (this.postedChecks.find(v => v.id === checks[i].id)) continue
          this.postedChecks.push(checks[i])
          this.$emit('updatePostedChecks', this.postedChecks)
        }
      },
      /**
       * Create a check form for a given AP
       * @param check
       */
      addCheck (check) {
        this.checkKey++
        this.checkPreviews.push({
          check: `check_${this.checkKey}`,
          form: this.buildCheckForm(check)
        })
      },
      /**
       * Build the check form, with data from the check quotes
       * @param check
       * @return {Object}
       */
      buildCheckForm (check) {
        let relatedTransactions = []
        let periodId = check.period
        let bankTransactionNumber = ''
        let paymentType
        if (check.related_transactions && check.related_transactions.length) {
          if (typeof check.related_transactions[0] === 'object') {
            relatedTransactions = [...new Set(check.related_transactions.map(v => v.id))]
            bankTransactionNumber = check.related_transactions[0].bank_transaction_number || ''
            paymentType = check.related_transactions[0].payment_type || 'CHECK'
          } else {
            relatedTransactions = check.related_transactions
          }
        }
        const useBankTrxNumber = this.paymentType === 'CHECK_MANUAL' || this.btNumberSettings && this.btNumberSettings[paymentType]
        let checkNumber = useBankTrxNumber ? bankTransactionNumber : ''
        let checkId = null
        if (check.status === 'DRAFT') {
          checkNumber = (useBankTrxNumber ? bankTransactionNumber : '') || check.number
          checkId = check.id
        }
        if (check.period && typeof check.period === 'object') {
          periodId = check.period.id
        }
        return {
          account_cash: check.account_cash.id || '',
          account_clearing: check.account_clearing.id || '',
          amount_decimal: check.amount_decimal ? check.amount_decimal : '0.00',
          bank: this.getBankById(check.batch.bank) || '',
          batch: check.batch || '',
          company: {
            label: this.getCompanyById(check.batch.company).name || '',
            value: this.getCompanyById(check.batch.company).id || ''
          },
          date: check.payment_date || this.defaultCheckDate || null,
          description: check.description,
          id: checkId,
          number: checkNumber,
          payee_name: check.payee_name || '',
          payee_address: check.payee_address || '',
          period: periodId || this.currentPeriod.id || null,
          pickup: check.pickup || false,
          status: 'DRAFT',
          payment_combine_checks: check.payment_combine_checks,
          vendor: check.vendor.id || '',
          related_transactions: relatedTransactions,
          reprint: false
        }
      },
      updateTransactions (preview, column) {
        this.updatingTransactions = true
        if (!(preview.form.related_transactions && preview.form.related_transactions.length)) {
          this.updatingTransactions = false
          return false
        }
        let promises = []
        switch (column) {
          case 'payment_combine_checks':
            preview.form.related_transactions.forEach((transaction) => {
              promises.push(this.$store.dispatch(`updateAp`, { id: transaction, data: { payment_combine_checks: preview.form.payment_combine_checks } }))
            })
            break
        }
        if (promises.length) {
          Promise.all(promises)
            .then(() => {
              this.error = null
              this.startingCheckNumbers = {}
              this.checks = []
              this.checkPreviews = []
              this.checkPdfReady = false
              this.building = false
              this.buildProgress = 0
              this.checkKey = 0
              this.printErrors = false
              this.enableReprintBtn = false
              this.checkRuns = []
              this.paymentTypeUpdated = false
              this.$emit('printChecks')
              this.updatingTransactions = false
              this.updatingCheckNumbers = false
              this.disablePrint = false
            })
            .catch(e => {
              this.updatingTransactions = false
              console.log(e)
            })
        }
      },
      /**
       * Sets the starting check numbers
       */
      setStartingCheckNumbers () {
        const bankCheckNums = this.getCheckNumbers[this.selectedBank]
        if (bankCheckNums && Array.isArray(bankCheckNums) && bankCheckNums.length) {
          this.startingCheckNumbers[this.selectedBank] = bankCheckNums[0]
        }
      },
      /**
       * Assigns check number to each check
       */
      assignCheckNumbers () {
        let assigned = {}
        this.checkPreviews.map((v, k) => {
          if (v.form.number) {
            return v
          }
          const checkNums = this.getCheckNumbers[v.form.bank.id]
          if (!(checkNums && Array.isArray(checkNums) && checkNums.length)) {
            return v
          }
          const bank = v.form.bank.id
          if (!assigned[bank]) {
            assigned[bank] = 0
          }
          if (checkNums[assigned[bank]]) {
            v.form.number = checkNums[assigned[bank]]
            if (checkNums.length - 1 > assigned[bank]) {
              assigned[bank] = assigned[bank] += 1
            }
          } else {
            v.form.number = ''
          }
          return v
        })
      },
      /**
       * Reprint checks
       */
      reprintChecks () {
        this.enableReprintBtn = false
        this.buildProgress = 0
        this.checkPdfReady = false
        this.printErrors = true
        this.goToPreviousStep()
      },
      /**
       * Update check numbers
       */
      updateCheckNumbers () {
        this.disablePrint = true
        if (!this.startingCheckNumbers[this.selectedBank]) {
          this.$notify({ title: 'Error', message: 'Invalid check number', type: 'error' })
          return
        }
        clearTimeout(this.searchTimeout)
        this.updatingCheckNumbers = true
        this.searchTimeout = setTimeout(async () => {
          const id = this.selectedBank
          if (!id) {
            this.updatingCheckNumbers = false
            this.disablePrint = false
            return
          }
          try {
            this.$store.dispatch('fetchCheckNumbers', {
              id,
              params: {
                amount: this.getNumOfChecksToPrintPerBank()[id],
                range_start: this.startingCheckNumbers[id]
              }
            })
            .then((r) => {
              if (r) {
                if (!r.length) {
                  this.$notify({ title: 'Error', message: 'Invalid check number', type: 'error' })
                  return
                }
                if (this.checksToPrint && this.checksToPrint.length) { // Build data element containing first avail check numbers
                  this.checkPreviews = []
                  this.checksToPrint.forEach(check => this.addCheck(check))
                  this.assignCheckNumbers()
                  this.disablePrint = false
                }
              }
            })
          } catch (e) {
            console.log(e)
            this.$notify({ title: 'Error', message: 'Error re-numbering checks', type: 'error' })
          }
          this.updatingCheckNumbers = false
        }, 500)
      },
      handlePrintErrCheckboxChange () {
        let printErrs = this.checks.filter(v => v.printErr)
        this.enableReprintBtn = !!(printErrs && printErrs.length)
      },
      /**
       * Reset data properties, used when the modal is closed
       */
      resetFields () {
        this.error = null
        this.active = 0
        this.startingCheckNumbers = {}
        this.checks = []
        this.checkPreviews = []
        this.checkPdfReady = false
        this.building = false
        this.buildProgress = 0
        this.checkKey = 0
        this.printErrors = false
        this.enableReprintBtn = false
        this.checkRuns = []
        this.updatingTransactions = false
        this.disablePrint = false
        if (!this.changingPaymentMethod) {
          this.$emit('updatePostedChecks', [])                                                                // Update list of posted checks on parent component
          this.$emit('resetParentFields')                                                                     // Resets relevant fields on the parent component
        }
      },
      /**
       * Close the modal dialog box, reset fields on this component and on the parent
       */
      closeCheckPrinter () {
        this.$refs.checkCarousel.setActiveItem(0)
        this.dialogVisible = false
      },
      getCurrencySymbol (data) {
        return data.currency_data ? data.currency_data.symbol : '$'
      },
      handlePaymentMethod () {
        this.error = null
        this.startingCheckNumbers = {}
        this.checks = []
        this.checkPreviews = []
        this.checkPdfReady = false
        this.building = false
        this.buildProgress = 0
        this.checkKey = 0
        this.printErrors = false
        this.enableReprintBtn = false
        this.checkRuns = []
        this.loading = true
        this.changingPaymentMethod = true
        this.paymentTypeUpdated = false
        this.$emit('printChecks', { payment_method: this.payment_method })
      }
    },
    computed: {
      ...mapGetters({
        getCompanyById: 'getCompanyById',
        getCompanyByBatchId: 'getCompanyByBatchId',
        getBankById: 'getBankById',
        getBankByCompanyId: 'getBankByCompanyId',
        getBankByBatchId: 'getBankByBatchId',
        currentPeriod: 'getCurrentPeriod',
        getPeriodById: 'getPeriodById',
        getVendorById: 'getVendorById',
        getCheckNumbers: 'getCheckNumbers',
        getCheckrunPdf: 'getCheckrunPdf',
        getCheckrunPdfUrl: 'getCheckrunPdfUrl',
        getCachedParamById: 'getCachedParamById',
        getReportFetchStatus: 'getReportFetchStatus'
      }),
      /**
       * Computed property that returns the available options for the period dropdown field
       */
      periodOptions () {
        const options = [{ label: 'Next', value: null }]
        if (this.currentPeriod && this.currentPeriod.id) {
          options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        return options
      },
      /**
       * Computed property that returns a boolean indicating whether a report is currently being processed
       * @return boolean
       */
      processingReport () {
        return !!(this.getReportFetchStatus && this.getReportFetchStatus.status || this.cachingParams)
      },
      /**
       * Returns the parsed BT_NUMBER_SETTINGS object e.g. { CHECK: false, EFT: true, WIRE: false }.
       * Controls whether bank_transaction_number is used as the check number per payment type.
       */
      btNumberSettings () {
        const { getUiSettings } = this.$store.getters
        try {
          const value = getUiSettings && getUiSettings['BT_NUMBER_SETTINGS']
          return value ? JSON.parse(value) : null
        } catch (e) {
          console.warn('Invalid BT_NUMBER_SETTINGS value. Expected JSON like {"CHECK": false, "EFT": false, "WIRE": false}.')
          return null
        }
      },
      /**
       * Computed property that returns the allowable check date range, if any.
       */
      checkDateRange () {
        const { getUiSettings } = this.$store.getters
        const defaultRange = { start: -14, end: 14 }
        try {
          if (getUiSettings['CHECK_DATE_RANGE']) {
            const range = JSON.parse(getUiSettings['CHECK_DATE_RANGE'])
            if (range && typeof range.start === 'number' && typeof range.end === 'number' && range.start < range.end) {
              return { start: range.start, end: range.end }
            } else {
              throw new RangeError()
            }
          } else {
            throw new Error()
          }
        } catch (e) {
          let msg = 'No CHECK_DATE_RANGE setting specified. Falling back to default range of 14 days pre-dated ' +
            'and 14 days post-dated.'
          if (e instanceof RangeError) {
            msg = 'Invalid CHECK_DATE_RANGE parameter values. Setting must specify integer values ' +
              "for 'start' (optional) and 'end', where 'start' must be less than 'end', representing the start and " +
              'end of a date range as the number of days relative to the current date. Falling back to default range ' +
              'of 14 days pre-dated and 14 days post-dated (start: -14, end: 14).'
          }
          console.warn(msg)
          return defaultRange
        }
      },
      /**
       * Returns the string representation of the date range for which a check date must be between.
       */
      allowableDateRangeString () {
        const nDaysAgo = new Date(Date.now())
        const nDaysFromNow = new Date(Date.now())
        nDaysAgo.setDate(nDaysAgo.getDate() + this.checkDateRange.start)
        nDaysFromNow.setDate(nDaysFromNow.getDate() + this.checkDateRange.end)
        return `${new Date(nDaysAgo).toLocaleDateString()} - ${new Date(nDaysFromNow).toLocaleDateString()}`
      },
      /**
       * Returns the default check date, depending on the start and end values of this.checkDateRange.
       */
      defaultCheckDate () {
        const { start, end } = this.checkDateRange
        const startDate = new Date(Date.now())
        if (start < 0 && end > 0) {
          startDate.toLocaleDateString()
        } else if (start < 0 && end === 0) {
          startDate.setDate(startDate.getDate() + end)
        } else {
          startDate.setDate(startDate.getDate() + start)
        }
        return getSimpleDate(new Date(startDate), 'yyyy-mm-dd')
      }
    },
    watch: {
      /**
       * Build form on prop change
       */
      checksToPrint () {
        this.changingPaymentMethod = false
        if (this.checksToPrint && this.checksToPrint.length) { // Build data element containing first avail check numbers
          this.checksToPrint.forEach(check => this.addCheck(check))
        }
      },
      draftChecks () {
        this.checkPreviews = []
        this.checkKey = 0
        if (this.draftChecks && this.draftChecks.length) { // Build data element containing first avail check numbers
          this.draftChecks.forEach(check => this.addCheck(check))
        }
      },
      /**
       * Shows or hides the CheckPrinter component
       */
      checkPrinterVisible () {
        this.dialogVisible = this.checkPrinterVisible
      },
      getCheckNumbers () {
        this.setStartingCheckNumbers()
        const numberOfCheckNums = Object.values(this.getCheckNumbers).map(v => v.length).reduce((a, b) => a + b, 0)
        if (this.checksToPrint && (numberOfCheckNums === this.checksToPrint.length)) {
          this.assignCheckNumbers()
        }
      }
    }
  }
</script>

<style>
  td input {
    border: none !important;
    height: 22px !important;
    text-align: left;
  }
  .el-input {
    font-size: 12px;
  }
  .el-select .el-input__inner {
    padding-right: 0;
  }
</style>

<style scoped>
  .check-amt-field {
    text-align: right !important;
  }
  .check-form-label {
    padding: 10px 0;
  }
  .check-form-field {
    padding: 10px 0;
  }
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    border: 1px solid #ccc;
  }
  .cell-gray {
    background: #eaeaea;
  }
  .cell-padded {
    padding: 6px 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Programs/CheckProcessing/CheckPrinter.vue